module.exports = __webpack_public_path__ + "static/img/brees-2008-top.830946c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-top.jpg
// module id = Do8M
// module chunks = 1